import { DomainLocaleConfig } from '@/shared/types';

export const TERMS_HREF_CONFIG: Record<
  'LEGAL_INFO' | 'PRIVACY_POLICY' | 'LICENSE_AGREEMENT',
  DomainLocaleConfig
> = {
  LEGAL_INFO: {
    ru: {
      ru: 'https://law.2gis.ru',
      kz: 'https://law.2gis.ru',
      en: 'https://law.2gis.ru',
      ge: 'https://law.2gis.ru',
      am: 'https://law.2gis.ru',
      tg: 'https://law.2gis.ru',
    },
    kz: {
      ru: 'https://law.2gis.kz/ru',
      kz: 'https://law.2gis.kz',
      en: 'https://law.2gis.kz',
      ge: 'https://law.2gis.kz',
      am: 'https://law.2gis.kz',
      tg: 'https://law.2gis.kz',
    },
    com: {
      ru: 'https://law.2gis.ru',
    },
    ge: {
      ru: 'https://law.2gis.ge/ru',
      kz: 'https://law.2gis.ge',
      en: 'https://law.2gis.ge',
      ge: 'https://law.2gis.ge',
      am: 'https://law.2gis.ge',
      tg: 'https://law.2gis.ge',
    },
    am: {
      ru: 'https://law.2gis.ru',
      kz: 'https://law.2gis.am',
      en: 'https://law.2gis.am',
      ge: 'https://law.2gis.am',
      am: 'https://law.2gis.am',
      tg: 'https://law.2gis.am',
    },
    tj: {
      ru: 'https://law.2gis.tj/ru ',
      kz: 'https://law.2gis.tj',
      en: 'https://law.2gis.tj',
      ge: 'https://law.2gis.tj',
      am: 'https://law.2gis.tj',
      tg: 'https://law.2gis.tj',
    },
  },
  PRIVACY_POLICY: {
    ru: {
      ru: 'https://law.2gis.ru/privacy',
      kz: 'https://law.2gis.ru/privacy',
      en: 'https://law.2gis.ru/privacy',
      ge: 'https://law.2gis.ru/privacy',
      am: 'https://law.2gis.ru/privacy',
      tg: 'https://law.2gis.ru/privacy',
    },
    kz: {
      ru: 'https://law.2gis.kz/privacy/ru',
      kz: 'https://law.2gis.kz/privacy',
      en: 'https://law.2gis.kz/privacy',
      ge: 'https://law.2gis.kz/privacy',
      am: 'https://law.2gis.kz/privacy',
      tg: 'https://law.2gis.kz/privacy',
    },
    com: {
      ru: 'https://law.2gis.ru/privacy',
      kz: 'https://law.2gis.ru/en/privacy',
      en: 'https://law.2gis.ru/en/privacy',
      ge: 'https://law.2gis.ru/en/privacy',
      am: 'https://law.2gis.ru/en/privacy',
      tg: 'https://law.2gis.ru/en/privacy',
    },
    ge: {
      ru: 'https://law.2gis.ru/privacy',
      kz: 'https://law.2gis.ge/privacy',
      en: 'https://law.2gis.ge/privacy',
      ge: 'https://law.2gis.ge/privacy',
      am: 'https://law.2gis.ge/privacy',
      tg: 'https://law.2gis.ge/privacy',
    },
    am: {
      ru: 'https://law.2gis.ru/privacy',
      kz: 'https://law.2gis.am/privacy',
      en: 'https://law.2gis.am/privacy',
      ge: 'https://law.2gis.am/privacy',
      am: 'https://law.2gis.am/privacy',
      tg: 'https://law.2gis.am/privacy',
    },
    tj: {
      ru: 'https://law.2gis.tj/privacy/ru',
      kz: 'https://law.2gis.tj/privacy',
      en: 'https://law.2gis.tj/privacy',
      ge: 'https://law.2gis.tj/privacy',
      am: 'https://law.2gis.tj/privacy',
      tg: 'https://law.2gis.tj/privacy',
    },
  },
  LICENSE_AGREEMENT: {
    ru: {
      ru: 'https://law.2gis.ru/about-2gis',
      kz: 'https://law.2gis.ru/about-2gis',
      en: 'https://law.2gis.ru/about-2gis',
      ge: 'https://law.2gis.ru/about-2gis',
      am: 'https://law.2gis.ru/about-2gis',
      tg: 'https://law.2gis.ru/about-2gis',
    },
    kz: {
      ru: 'https://law.2gis.kz/about-2gis/ru',
      kz: 'https://law.2gis.kz/about-2gis',
      en: 'https://law.2gis.kz/about-2gis',
      ge: 'https://law.2gis.kz/about-2gis',
      am: 'https://law.2gis.kz/about-2gis',
      tg: 'https://law.2gis.kz/about-2gis',
    },
    com: {
      ru: 'https://law.2gis.ru/about-2gis',
      kz: 'https://law.2gis.ru/en/rules',
      en: 'https://law.2gis.ru/en/rules',
      ge: 'https://law.2gis.ru/en/rules',
      am: 'https://law.2gis.ru/en/rules',
      tg: 'https://law.2gis.ru/en/rules',
    },
    ge: {
      ru: 'https://law.2gis.ge/licensing-agreement/ru',
      kz: 'https://law.2gis.ge/licensing-agreement',
      en: 'https://law.2gis.ge/licensing-agreement',
      ge: 'https://law.2gis.ge/licensing-agreement',
      am: 'https://law.2gis.ge/licensing-agreement',
      tg: 'https://law.2gis.ge/licensing-agreement',
    },
    am: {
      ru: 'https://law.2gis.ru/about-2gis',
      kz: 'http://law.2gis.am/licensing-agreement/',
      en: 'http://law.2gis.am/licensing-agreement/',
      ge: 'http://law.2gis.am/licensing-agreement/',
      am: 'http://law.2gis.am/licensing-agreement',
      tg: 'http://law.2gis.am/licensing-agreement/',
    },
    tj: {
      ru: 'https://law.2gis.tj/licensing-agreement/ru',
      kz: 'https://law.2gis.tj/licensing-agreement',
      en: 'https://law.2gis.tj/licensing-agreement',
      ge: 'https://law.2gis.tj/licensing-agreement',
      am: 'https://law.2gis.tj/licensing-agreement',
      tg: 'https://law.2gis.tj/licensing-agreement',
    },
  },
};
